var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-link',{staticClass:"play-btn",attrs:{"icon-color":"white","icon-size":"46px","icon-f7":"play_fill"},on:{"click":_vm.onClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }